
import React from 'react'
import { connect } from 'react-redux'
import { Segment, Grid } from 'semantic-ui-react'
import { reduxForm } from 'redux-form'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { date as dateFormatter, dateTime as dateTimeFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
//@ts-ignore
import FormField from 'shared/newFormElements'
import { translateCmd, translateWebMessages, icon, addDays } from '../helpers'
import SendSMSModal, { SMSModalName } from './SMSSendModal'
import { formName, SMS_FORM_NAME } from '../constants'
import { constants as DCConstants, actions as DCActions } from '../../DetailsContainer'
import withLivedata from '../../shared/containers/withLivedata'
import { SmsTabProps } from '../types'
import { MomentInput } from 'moment'
const config = {
  instanceName: undefined,
  gridIdentity: { formName, objectName: 'dbgrd_sms' },
  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,
  columnConfigs: {
    OperDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    SendDate: {
      valueFormatter: ({ value }) => dateTimeFormatter(value),
    },
  },
  getContextMenuItems: () => ['excelExport'],
}

//@ts-ignore
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDay'])
//@ts-ignore
@connect(
(state, { OpenDay, ID }: {OpenDay: string, ID: string}) => ({
    initialValues: {
      StartDate: addDays(OpenDay, -1),
      EndDate: OpenDay,
    },
    form: SMS_FORM_NAME + ID,
  }),
  //@ts-ignore
(dispatch, { ID, hash }) => ({
    fetch: (data) => dispatch(DCActions.fetchPage({ type: 'Client', ID, hash, page: 'sms', additionalParams: data })),
  }),
)
//@ts-ignore
@reduxForm({
  destroyOnUnmount: false,
  validate: (values: {StartDate: MomentInput, EndDate: MomentInput}) => {
    const errors: {
      StartDate?: string,
      EndDate?: string
    } = {}

    if (!LKDate.isValid(values.StartDate) || LKDate.from(values.StartDate) > LKDate.from(values.EndDate)) {
      errors.StartDate = translateWebMessages('INVALID_DATE')
    }

    if (!LKDate.isValid(values.EndDate) || LKDate.from(values.EndDate) < LKDate.from(values.StartDate)) {
      errors.EndDate = translateWebMessages('INVALID_DATE')
    }

    return errors
  },

  onSubmit: (values, _, { fetch }) => {
    fetch(values)
  },
})
class SMS extends React.Component<SmsTabProps> {
  render() {
    const {
      ID,
      hash,
      data: {
        sms,
        base: { FullName, CellPhone, Phone },
      },
      openSMSModal,
    } = this.props
    return (
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <LKGrid rowData={sms} {...config} instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-SMS`} />
            </TableContainer>
          </FlexTableChild>

          <Segment>
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={2}>
                    <FormField type="date" name="StartDate" upward />
                  </Grid.Column>

                  <Grid.Column textAlign="left" width={2}>
                    <FormField name="EndDate" type="date" upward />
                  </Grid.Column>

                  <Grid.Column textAlign="left" width={3}>
                    <LKButton alias="refresh" size="tiny" onClick={this.props.handleSubmit}>
                      {translateCmd('refresh_sms')}
                    </LKButton>

                    <LKGridExportButton alias="export" size="tiny" instanceName={config?.instanceName} />
                  </Grid.Column>

                  <Grid.Column textAlign="right" width={9}>
                    <SendSMSModal
                      fetchPage={this.props.handleSubmit}
                      client={FullName}
                      cellPhone={CellPhone}
                      phone={Phone}
                      ID={ID}
                      hash={hash}
                    />

                    <LKButton alias="sms" onClick={openSMSModal}>
                      {translateCmd('send_sms')}
                    </LKButton>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Segment>
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

const container = connect(undefined, {
  openSMSModal: () => LKModalActions.open({ name: SMSModalName }),
})

//@ts-ignore
SMS.config = {
  title: () => 'SMS',
  name: 'sms',
  component: container(SMS),
  api: [
    'base',
    {
      page: 'sms',
      fetchOnInit: false,
    },
  ],
  needsFreshData: 'sms',
  icon: icon('tb_sms'),
}

//@ts-ignore
SMS.defaultProps = {
  data: {
    sms: [],
  },
}

export default SMS
